<mat-card>
  <app-card-header
    [title]="'Columnas a exportar'"
    icono="file_download"
    [botonCerrar]="true"
    (cerrar)="onClose()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="ecv-columnas">
      @for (col of columnas; track col.key) {
        <mat-checkbox [(ngModel)]="col.activa">{{ col.label }}</mat-checkbox>
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="onClose()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="!hayAlgunaActiva"
      (click)="onExportar()"
    >
      <mat-icon>file_download</mat-icon>
      Exportar
    </button>
  </mat-card-actions>
</mat-card>
